import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74c07900"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 h-100" }
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = {
  id: "mydiv",
  class: "main-div-userapproval"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div style=\"width:calc(100% - 16px);\" data-v-74c07900><table id=\"tblUserApprovalInfo\" data-v-74c07900><thead data-v-74c07900><tr data-v-74c07900><th style=\"width:7%;\" data-v-74c07900>User Id</th><th style=\"width:8%;\" data-v-74c07900>Employee No.</th><th style=\"width:13%;\" data-v-74c07900>Given Name</th><th style=\"width:13%;\" data-v-74c07900>Family Name</th><th style=\"width:15%;\" data-v-74c07900>E-mail</th><th style=\"width:7%;\" data-v-74c07900>Department</th><th style=\"width:7%;\" data-v-74c07900>Title</th><th style=\"width:7%;\" data-v-74c07900>Station Code</th><th style=\"width:8%;\" data-v-74c07900>Permission Set</th><th style=\"width:8%;\" data-v-74c07900>Approval</th><th style=\"width:8%;\" data-v-74c07900>Deny</th></tr></thead></table></div>", 1)
const _hoisted_5 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_6 = {
  key: 1,
  id: "tblbodydiv",
  style: {"overflow":"auto","height":"calc(100% - 60px)"}
}
const _hoisted_7 = {
  id: "tblUserApprovalInfo",
  class: "w-100"
}
const _hoisted_8 = {
  id: "tbltbody",
  class: "w-100"
}
const _hoisted_9 = {
  key: 0,
  style: {"width":"7%"}
}
const _hoisted_10 = {
  key: 1,
  style: {"width":"7%"}
}
const _hoisted_11 = { style: {"width":"8%"} }
const _hoisted_12 = { style: {"width":"13%"} }
const _hoisted_13 = { style: {"width":"13%"} }
const _hoisted_14 = { style: {"width":"15%"} }
const _hoisted_15 = { style: {"width":"7%"} }
const _hoisted_16 = { style: {"width":"7%"} }
const _hoisted_17 = { style: {"width":"7%"} }
const _hoisted_18 = { style: {"text-align":"center","width":"8%"} }
const _hoisted_19 = ["onClick", "disabled"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Check ")
const _hoisted_21 = {
  key: 2,
  style: {"text-align":"center","width":"8%"}
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 3 }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 4,
  style: {"text-align":"center","width":"8%"}
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 5 }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  class: "modal fade",
  id: "showModal",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true"
}
const _hoisted_30 = { class: "modal-dialog modal-dialog-scrollable modal-lg" }
const _hoisted_31 = { class: "modal-content" }
const _hoisted_32 = { class: "modal-header" }
const _hoisted_33 = {
  class: "modal-title",
  id: "showModalLabel"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))
const _hoisted_35 = {
  class: "modal-body",
  id: "modal-body",
  style: {"text-align":"left","font-size":"13px","height":"70vh"}
}
const _hoisted_36 = { style: {"overflow-y":"auto"} }
const _hoisted_37 = { id: "tblPermissionModal" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { style: {"width":"5%","text-align":"center"} }
const _hoisted_40 = ["id", "onClick"]
const _hoisted_41 = { style: {"width":"40%","text-align":"left"} }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"55%","text-align":"left"} }, " ", -1 /* HOISTED */))
const _hoisted_43 = { style: {"width":"5%","text-align":"center"} }
const _hoisted_44 = ["id", "name", "onClick"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"40%","text-align":"left"} }, " ", -1 /* HOISTED */))
const _hoisted_46 = { style: {"width":"55%","text-align":"left"} }
const _hoisted_47 = { class: "modal-footer" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal",
  style: {}
}, " Close ", -1 /* HOISTED */))
const _hoisted_51 = {
  class: "modal fade",
  id: "denyModel",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true"
}
const _hoisted_52 = { class: "modal-dialog modal-dialog-scrollable modal-lg" }
const _hoisted_53 = {
  class: "modal-content",
  style: {"height":"250px"}
}
const _hoisted_54 = { class: "modal-header" }
const _hoisted_55 = {
  class: "modal-title",
  id: "showModalLabel"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))
const _hoisted_57 = {
  class: "modal-body",
  id: "modal-body",
  style: {"text-align":"left","font-size":"18px","height":"30px"}
}
const _hoisted_58 = { class: "modal-footer" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, " Close ", -1 /* HOISTED */))
const _hoisted_60 = {
  class: "modal fade",
  id: "approveModel",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true"
}
const _hoisted_61 = { class: "modal-dialog modal-dialog-scrollable modal-lg" }
const _hoisted_62 = {
  class: "modal-content",
  style: {"height":"375px","width":"1000px"}
}
const _hoisted_63 = { class: "modal-header" }
const _hoisted_64 = {
  class: "modal-title",
  id: "showModalLabel"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */))
const _hoisted_66 = {
  class: "modal-body",
  id: "modal-body",
  style: {"text-align":"left","font-size":"18px","height":"30px"}
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "User ID for SCAN", -1 /* HOISTED */))
const _hoisted_68 = { style: {"position":"relative","display":"inline-flex"} }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_70 = { style: {"text-align":"left","color":"red","font-size":"medium","margin-top":"0.5%"} }
const _hoisted_71 = {
  key: 0,
  id: "lblApproveError",
  style: {"text-align":"center","color":"red","font-size":"16px","margin-top":"1%"}
}
const _hoisted_72 = {
  key: 1,
  id: "lblApproveError",
  style: {"color":"red","font-size":"16px","margin-top":"1%","margin-left":"0%"}
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_74 = { class: "modal-footer" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "btnApproveModalCancel",
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, " Close ", -1 /* HOISTED */))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "btnHiddenConfirm",
  style: {"visibility":"hidden"},
  "data-bs-toggle": "modal",
  "data-bs-target": "#confirmOrAlertModel"
}, null, -1 /* HOISTED */))
const _hoisted_77 = {
  class: "modal fade",
  id: "confirmOrAlertModel",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true"
}
const _hoisted_78 = { class: "modal-dialog modal-dialog-scrollable modal-lg" }
const _hoisted_79 = {
  class: "modal-content",
  style: {"height":"240px","width":"650px"}
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "showModalLabel"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1 /* HOISTED */))
const _hoisted_81 = {
  class: "modal-body",
  id: "modal-body",
  style: {"text-align":"left","font-size":"18px","height":"30px"}
}
const _hoisted_82 = { key: 0 }
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" Attempt to register as new user who already possessed Authentication ID with this email ")
const _hoisted_84 = { style: {"color":"#325c84"} }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_86 = /*#__PURE__*/_createTextVNode("Are you sure to continue?")
const _hoisted_87 = { key: 1 }
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" Authentication ID request for different user with same email is not allowed.")
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_90 = /*#__PURE__*/_createTextVNode("Please check user name or reapply after denied the user request. ")
const _hoisted_91 = [
  _hoisted_88,
  _hoisted_89,
  _hoisted_90
]
const _hoisted_92 = { class: "modal-footer" }
const _hoisted_93 = {
  key: 0,
  type: "button",
  class: "btn btn-secondary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#approveModel"
}
const _hoisted_94 = {
  key: 2,
  type: "button",
  class: "btn btn-secondary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#approveModel",
  style: {"width":"75px"}
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "btnHiddenReOpen",
  style: {"visibility":"hidden"},
  "data-bs-toggle": "modal",
  "data-bs-target": "#approveModel"
}, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      ($setup.userApprovalInfo.length == 0 && $setup.isNoData)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_5, " No data "))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _createElementVNode("tbody", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userApprovalInfo[0], (info, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    (info.chkUser == 'TmpUser')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_9, " New User "))
                      : (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(info.userId), 1 /* TEXT */)),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(info.employeeNumber), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(info.givenName), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(info.familyName), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(info.email), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(info.department), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(info.title), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(info.stationCode), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_18, [
                      _createElementVNode("button", {
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#showModal",
                        onClick: ($event: any) => ($setup.modalShow1(info)),
                        class: "btn btn-primary button-design-scanUserApproval",
                        disabled: info.chkUser == 'ReAppUser'
                      }, [
                        _createCommentVNode(" Preview "),
                        _hoisted_20
                      ], 8 /* PROPS */, _hoisted_19)
                    ]),
                    (info.chkUser == 'TmpUser')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                          _createElementVNode("button", {
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#approveModel",
                            onClick: ($event: any) => ($setup.showApproveModal(info)),
                            class: "btn btn-primary button-design-scanUserApproval"
                          }, " Approve ", 8 /* PROPS */, _hoisted_22)
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_23, [
                          _createElementVNode("button", {
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#showModal",
                            onClick: ($event: any) => ($setup.modalShow1(info)),
                            class: "btn btn-primary button-design-scanUserApproval"
                          }, " Approve ", 8 /* PROPS */, _hoisted_24)
                        ])),
                    (info.chkUser == 'TmpUser')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_25, [
                          _createElementVNode("button", {
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#denyModel",
                            onClick: ($event: any) => ($setup.showDenyModel(info.employeeNumber, info.chkUser, info.email, info.familyName, info.givenName)),
                            class: "btn btn-primary button-design-scanUserApproval"
                          }, " Deny ", 8 /* PROPS */, _hoisted_26)
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_27, [
                          _createElementVNode("button", {
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#denyModel",
                            onClick: ($event: any) => ($setup.showDenyModel(info.userId, info.chkUser, info.email, info.familyName, info.givenName)),
                            class: "btn btn-primary button-design-scanUserApproval"
                          }, " Deny ", 8 /* PROPS */, _hoisted_28)
                        ]))
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]))
    ]),
    _createCommentVNode(" Permission Set Modal "),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("h5", _hoisted_33, _toDisplayString($setup.modalSubject[0]), 1 /* TEXT */),
            _hoisted_34
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("table", _hoisted_37, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.permissionSetInfo[0], (item, index) => {
                  return (_openBlock(), _createElementBlock("tbody", {
                    id: "usertbltbody",
                    key: index
                  }, [
                    (item.data.length != 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_38, [
                          _createElementVNode("td", _hoisted_39, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              id: 'chkHeader' + item.mainTitleCode,
                              style: {"visibility":"hidden"},
                              onClick: ($event: any) => ($setup.chkHeaderChange(item.mainTitleCode, index))
                            }, null, 8 /* PROPS */, _hoisted_40)
                          ]),
                          _createElementVNode("td", _hoisted_41, _toDisplayString(item.mainTitleName), 1 /* TEXT */),
                          _hoisted_42
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (subTitleItem, subTitleIndex) => {
                      return (_openBlock(), _createElementBlock("tr", { key: subTitleIndex }, [
                        _createElementVNode("td", _hoisted_43, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            id: 'chk' + subTitleItem.mainMenuCode,
                            name: 'chk' + item.mainTitleCode,
                            onClick: ($event: any) => ($setup.chkChange(item.mainTitleCode, subTitleIndex))
                          }, null, 8 /* PROPS */, _hoisted_44)
                        ]),
                        _hoisted_45,
                        _createElementVNode("td", _hoisted_46, _toDisplayString(subTitleItem.mainMenuName), 1 /* TEXT */)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            ($setup.userType == 'TmpUser')
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.btnClose($setup.targetEmpNo, $setup.targetstationCode)))
                  }, " Close ")
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("button", {
                    type: "button",
                    id: "btnReAppApprove",
                    class: "btn btn-primary button-design",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.btnReAppApprove($setup.targetUserId)))
                  }, " Approve ")
                ]))
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Deny Button Modal "),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("h5", _hoisted_55, _toDisplayString($setup.modalSubject[0]), 1 /* TEXT */),
            _hoisted_56
          ]),
          _createElementVNode("div", _hoisted_57, _toDisplayString($setup.modalBody[0]), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _createElementVNode("button", {
              type: "button",
              id: "btnFinalApprove",
              class: "btn btn-primary button-design",
              "data-bs-dismiss": "modal",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.DenyBtnClk($setup.targetUserId, $setup.userType)))
            }, " Deny ")
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Approve Modal "),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("h5", _hoisted_64, _toDisplayString($setup.approveModalSubject[0]), 1 /* TEXT */),
            _hoisted_65
          ]),
          _createElementVNode("div", _hoisted_66, [
            _hoisted_67,
            _createElementVNode("div", _hoisted_68, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                id: "txtAuthenticationId",
                style: {"width":"200px"},
                maxlength: "8",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.approveModalBody[0]) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.approveModalBody[0]]
              ]),
              ($setup.isEditableAuthID)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btnAuthEdit",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.btnEditAuthID()))
                  }, " Edit "))
                : _createCommentVNode("v-if", true)
            ]),
            _hoisted_69,
            _createElementVNode("span", _hoisted_70, _toDisplayString($setup.authIDFormatError), 1 /* TEXT */),
            ($setup.isEditableAuthID)
              ? (_openBlock(), _createElementBlock("label", _hoisted_71, _toDisplayString($setup.approveModalBody[1]), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("label", _hoisted_72, [
                  _createTextVNode(_toDisplayString($setup.approveModalBody[1]), 1 /* TEXT */),
                  _hoisted_73,
                  _createTextVNode(" " + _toDisplayString($setup.approveModalBody[2]), 1 /* TEXT */)
                ]))
          ]),
          _createElementVNode("div", _hoisted_74, [
            _hoisted_75,
            _createElementVNode("button", {
              type: "button",
              id: "btnFinalApprove",
              class: "btn btn-primary button-design",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (
              $setup.ApproveBtnClk(
                $setup.approveModalBody[0],
                $setup.userType,
                $setup.targetUserId,
                $setup.targetEmpNo,
                $setup.targetGivenName,
                $setup.targetFamilyName,
                $setup.targetstationCode,
                $setup.targetCompanyName,
                $setup.targetemail,
                $setup.threeDigitCode
              )
              ))
            }, " Approve "),
            _hoisted_76
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Confirm or Alert for user with edited Authentication ID Button Modal "),
    _createElementVNode("div", _hoisted_77, [
      _createElementVNode("div", _hoisted_78, [
        _createElementVNode("div", _hoisted_79, [
          _hoisted_80,
          _createElementVNode("div", _hoisted_81, [
            ($setup.isConfirmFlg)
              ? (_openBlock(), _createElementBlock("span", _hoisted_82, [
                  _hoisted_83,
                  _createElementVNode("span", _hoisted_84, [
                    _createTextVNode("( " + _toDisplayString($setup.targetemail) + " ) ", 1 /* TEXT */),
                    _hoisted_85,
                    _hoisted_86
                  ])
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_87, _hoisted_91))
          ]),
          _createElementVNode("div", _hoisted_92, [
            ($setup.isConfirmFlg)
              ? (_openBlock(), _createElementBlock("button", _hoisted_93, " Cancel "))
              : _createCommentVNode("v-if", true),
            ($setup.isConfirmFlg)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  id: "btnFinalApprove",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.confirmAuthIDApprove())),
                  class: "btn btn-primary button-design",
                  style: {"width":"75px"}
                }, " OK "))
              : (_openBlock(), _createElementBlock("button", _hoisted_94, " OK ")),
            _hoisted_95
          ])
        ])
      ])
    ])
  ]))
}